<template>
  <div class="row">
    <div class="col-12 mb-1">
      Para asegurarnos que una persona es quien dice ser, Escritorio Digital
      provee para algunos de sus servicios un 2FA, lo que permite validar,
      además de la contraseña del usuario, una segunda contraseña del tipo OTP
      (One-Time Password, en español: Contraseña de un solo uso), la
      cual es sólo visible a través de un dispositivo móvil, como
      tu smartphone, por unos cuantos segundos.
    </div>
    <div class="col-12 mb-1">
      <b>Como configurar 2FA?</b>
    </div>
    <div class="col-12 mb-1">
      <ul style="list-style-type: none">
        <li>1.- Descarga en tu dispositivo móvil la aplicación <b>Google Authenticator</b>
          (disponible en
          App Store de IOS y Play Store de Android).
        </li>
        <li>2.- Presiona el botón de mas abajo llamado <b>"Enviar mi código QR"</b>.</li>
        <li>3.- Abre la aplicación <b>Google Authenticator</b> y sigue las instrucciones para
          escanear un
          nuevo codigo QR.
        </li>
        <li>4.- Escanea el código QR que fue enviado a tu correo electrónico.</li>
        <li>5.- Para verificar que todo ha quedado correctamente configurado, ingresa mas abajo el
          código
          de 6 dígitos para validar.
        </li>
      </ul>
    </div>
    <div class="col-12 mb-1">
      <b>Importante: </b> Si ya habias configurado con anterioridad 2FA de
      <b> Escritorio Digital </b> con
      <b> Google Authenticator </b> y vuelves a enviar un código QR a tu correo electrónico, la
      configuración anterior dejará de ser válida. Puedes hacer esto tambien, si crees que ha sido
      comprometida la seguridad del código QR o cambiaste de dispositivo móvil.
    </div>
    <div class="col-12 mb-1">
      <div class="row">
        <div class="col-lg-4 col-md-6 text-center mt-3">
          <vs-input
            v-validate="'numeric|required|min:4|max:6'"
            class="w-full"
            name="otp"
            icon-pack="material-icons"
            icon="account_circle"
            icon-no-border
            label="Código OTP de Google Authenticator"
            :value="form.otp"
            @input="actualiza('otp', $event)"
          ></vs-input>
          <span class="text-danger text-sm">{{ errors.first('otp') }}</span>
        </div>
        <div class="col-lg-4 col-md-3 text-center mt-3">
          <vx-tooltip text="Al hacer click verificara el OPT" position="top">
            <vs-button
              class="mt-5"
              type="border"
              v-show="!form.checking"
              @click="sendToVerifyOTP"
            >
              Verificar
            </vs-button>
          </vx-tooltip>
          <b-spinner
            small
            variant="primary"
            v-show="form.checking"
          />
        </div>
        <div class="col-lg-4 col-md-3 text-center mt-3">
          <vx-tooltip text="Solicitar nuevo codigo OTP" position="top">
            <vs-button
              class="mt-5"
              type="border"
              v-show="!form.checking"
              @click="sendNew"
            >
              Enviar mi Código QR
            </vs-button>
          </vx-tooltip>
          <b-spinner
            small
            variant="primary"
            v-show="form.checking"
          />
        </div>
      </div>
    </div>
    <b-toast id="solicitar-ok">
      <span>Se envio nuevo codigo OTP</span>
    </b-toast>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  mixins: [],
  components: {},
  data() {
    return {
      form: {
        checking: false,
        otp: ''
      }
    };
  },
  watch: {},
  computed: {
    ...mapGetters('Empresas', [
      'company',
      'substitutes'
    ]),
    ...mapGetters('Usuario', [
      'currentUser',
      'loading',
      'sendingOtpAction'
    ])
  },
  methods: {
    ...mapActions('Usuario', [
      'sendNewOTP',
      'verifyOTP'
    ]),
    actualiza(key, value) {
      this.form[key] = value;
    },
    async sendToVerifyOTP() {
      const formValid = await this.validateForm();
      if (formValid) {
        this.form.checking = true;
        try {
          await this.verifyOTP({ otp: this.form.otp, user: this.currentUser });
          this.$bvToast.toast(
            'Genial! Tu otp funciona a la perfección!!',
            {
              title: '2FA',
              variant: 'primary',
              pauseOnHover: true,
              solid: true,
              noAutoHide: true
            }
          );
        } finally {
          this.form.checking = false;
        }
      }
    },
    async sendNew() {
      this.form.checking = true;
      try {
        await this.sendNewOTP(this.currentUser);
        this.$bvToast.toast(
          'Genial! Se ha enviado el nuevo OTP',
          {
            title: '2FA',
            variant: 'info',
            pauseOnHover: true,
            solid: true,
            noAutoHide: true
          }
        );
      } finally {
        this.form.checking = false;
      }
    },
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    }
  }
};
</script>
